import { ownerOf, type CalItem } from './calendarItems';

/** „Artur Sabanadze“ → „AS“, „Max“ → „MA“, ohne Namen „?“ */
export function initials(name: string | null): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

/** Feste Farbe je Person, aus der Benutzer-ID abgeleitet. Gleiche Person, gleiche Farbe, in jedem Monat und auf jedem Gerät. */
const PALETTE = 10;
function colorIndex(userId: string): number {
  let hash = 0;
  for (const c of userId) hash = (hash * 31 + c.charCodeAt(0)) >>> 0;
  return hash % PALETTE;
}

/**
 * Initialen der Person, der ein Kalendereintrag gehört, in einem Kreis (KON-117). Der volle Name steht im Tooltip und für Screenreader. Bei mehreren Teilnehmern
 * folgt „+n“.
 */
export function PersonDot({ item, nameOf }: { item: CalItem; nameOf: (id: string) => string | null }) {
  const { userId, more } = ownerOf(item);
  if (!userId) return null;
  const name = nameOf(userId);
  const label = `${name ?? 'Nicht mehr verfügbar'}${more ? ` und ${more} weitere` : ''}`;
  return (
    <span className="person-dot__wrap" title={label}>
      <span className={`person-dot person-dot--${colorIndex(userId)}`} aria-hidden="true">{initials(name)}</span>
      {more > 0 && <span className="person-dot__more" aria-hidden="true">+{more}</span>}
      <span className="sr-only">{label}: </span>
    </span>
  );
}
